export const NAME = 'aboutUs';